/**
 * @param {Array} activities - Activities with cart configuration fields
 * @returns {string|null} Order-independent configuration, or null if incomplete
 */
export function getCustomCartConfiguration(activities) {
  if (!Array.isArray(activities) || activities.length === 0) return null;

  const configurations = [];
  for (const activity of activities) {
    const projects = Number(activity.projects);
    if (
      activity.makercart_id == null ||
      String(activity.makercart_id) === "" ||
      !Number.isFinite(projects) ||
      projects <= 0
    ) {
      return null;
    }

    configurations.push(
      JSON.stringify([
        String(activity.makercart_id),
        activity.grade ?? "",
        activity.focus ?? "",
        projects,
        Boolean(activity.includingPoster),
      ])
    );
  }

  // Sorting preserves duplicate activities while ignoring their display order.
  return JSON.stringify(configurations.sort());
}
